export default __webpack_public_path__ + "static/media/lief-man@3x.35a312a3.png";